module.exports = __webpack_public_path__ + "img/544-42dfb3.png";